import React from 'react';
import { Legend, Line, LineChart as RechartLineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export interface LineChartData {
  data: any[]
  keys: string[]
}

interface LineChartProps {
  width: number
  height: number
  data: LineChartData
}

const LineChart: React.FC<LineChartProps> = ({ width, height, data }) => (
  <ResponsiveContainer
    width="100%"
    height={height}
  >
    <RechartLineChart
      width={width}
      height={height}
      data={data.data}
    >
      {data.keys.map(key => (
        <Line
          key={key}
          type="monotone"
          dataKey={key}
          stroke="#8884d8"
        />
      ))}
      <Legend />
      <XAxis
        dataKey="name"
      />
      <Tooltip />
      <YAxis />
    </RechartLineChart>
  </ResponsiveContainer>
)

export default LineChart
